import { env } from 'next-runtime-env';

import type { AggregationsResults } from '@core/Entities/Search/Aggregations/Aggregations.entity';
import { fetchJson } from '@core/Utils/Fetch/FetchJson';
import { formatMMV } from '@core/Utils/MakeModel/FormatMMV';

import type { FilterParams } from '../../../Entities/Search/QueryParams.entity';

export const getMmvFiltersFromSlug = async (slug?: string[]) => {
  const output: FilterParams = {};
  if (!slug?.length) return output;

  const url = `${env('NEXT_PUBLIC_UK_I15_SEARCH_API_URL')}/count?field=${[
    'make',
    'model',
    'variant',
  ].join('&field=')}`;

  const aggs = await fetchJson<AggregationsResults>(url, {
    next: { revalidate: 60 },
  });

  const aggregations = aggs?.aggregations;
  if (!aggregations) return output;

  const possibleMakes = aggregations.make || {};

  // 1. For valid MMV slug, first item must be Make
  const makeId = formatMMV(slug[0], 'internal');
  const isFirstItemMake = Object.hasOwn(possibleMakes, makeId);
  if (isFirstItemMake) {
    output.make = [makeId];

    // url uses '-' api uses '_'
    const modelName = formatMMV(slug[1] || '', 'internal');
    const modelId = `${makeId}-${modelName}`;
    const possibleModels = aggregations.model?.[makeId]?.models || {};
    const isNextItemModel = Object.hasOwn(possibleModels, modelId);

    // 2. Valid model must be the second slug item
    if (isNextItemModel) {
      output.model = [modelId];

      const variantName = formatMMV(slug[2] || '', 'internal');
      const possibleVariantId = `${makeId}-${modelName}-${variantName}`;
      const possibleVariants = aggregations.variant?.[makeId]?.models?.[modelId]?.variants || {};
      const isNextItemVariant = Object.hasOwn(possibleVariants, possibleVariantId);

      // 3. Valid variant must be the third slug item
      if (isNextItemVariant) {
        output['variant-type'] = [possibleVariantId];
      }
    }
  }

  return output;
};
